module.exports = __webpack_public_path__ + "img/11_Methodical Organiser.1763b392.svg";